import angular from "angular";
import ObjednavkaRkCtrl from "./ObjednavkaRkCtrl";
import ObjednavkaDkCtrl from "./ObjednavkaDkCtrl";
import ObjednavkaRkHromadneCtrl from "./ObjednavkaRkHromadneCtrl";
import ObjednavkaDkHromadneCtrl from "./ObjednavkaDkHromadneCtrl";


export default angular.module("sonas.rk", [])
.directive('objednavkaRk', function($filter) {
    return {
        restrict:'E',
        scope:{
          "om":"="
        },
        template: require("./objednavka.rk.html"),
        controller: ObjednavkaRkCtrl,
        controllerAs: "ctrl"
    };
})
.directive('objednavkaDk', function($filter) {
    return {
        restrict:'E',
        scope:{
          "om":"="
        },
        template: require("./objednavka.dk.html"),
        controller: ObjednavkaDkCtrl,
        controllerAs: "ctrl"
    };
})
.config(function routes($stateProvider){
  $stateProvider
  .state("kapacita-hromadne", {
    url: "/kapacita/hromadne",
    template: require("./objednavka.rk.hromadne.html"),
    controller: ObjednavkaRkHromadneCtrl,
    controllerAs: "ctrl"
  })
  .state("kapacita-hromadne-plyn", {
    url: "/kapacita/plyn/hromadne",
    template: require("./objednavka.dk.hromadne.html"),
    controller: ObjednavkaDkHromadneCtrl,
    controllerAs: "ctrl"
  })
})
.name;


// WEBPACK FOOTER //
// ./src/RezervovanaKapacita/index.js